import { CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";

import DirectionCRUDTable from "../../components/CRUD/Tables/DirectionCRUDTable";
import {actCRUD, actFormCRUD} from "../../http";
import DashboardLayout from "../../layouts/Dashboard";
import {checkRoles} from "../../functions/checkRoles";
import {confirmDialog} from "../../components/Dialog/DialogDelete";
import useReload from "../../hooks/useReload";
import useRoles from "../../hooks/useRoles";
import { actFormTypeIds } from "../../models/actFormTypeIds";

const DirectionTable = () => {
  const { pathname } = useLocation()
  const { reload, reloadValue } = useReload();
  const [path, setPath] = useState(null);
  let isDSEK = `${pathname[1].toUpperCase()}${pathname.substring(2)}`.includes('DSEK')

  const { isCommittee } = useRoles();

  const [actForm, setActForm] = useState()
  useEffect(() => {
    let path = `${pathname[1].toUpperCase()}${pathname.substring(2)}`.replace('DSEK', '');
    setPath(path);
    actFormCRUD.search({
      "filter": {
        "number": {
          "operand1": path,
          "operator": 1
        }
      }
    }).then((data) => {
      if (data.result.length > 0)
        setActForm(data.result[0]);
      else
        setActForm({id: null});
    })
  }, [pathname])
  const employee = localStorage.employee ? JSON.parse(localStorage.employee) : {}
  const extraFilter = {    
    "orderType": {
      "operand1": isDSEK ? 2 : 1,
      "operator": 1
    },
    "form": {
      "typeId": {
        "operand1": actFormTypeIds.direction,
        "operator": "equals"
      }
    }
  }

  if (actForm?.id) {
    extraFilter.formId = {
      "operand1": actForm?.id,
      "operator": 'equals'
    };
  }

  const handleDelete = (_) => {
    return confirmDialog('Удаление направления, ID:' + _, 'Вы действительно хотите удалить этот акт?', async () => {
      await actCRUD.delete(_);
      await reload();
    })
  }

  const readonly = path == 'Direction' || path == 'DirectionDSEK';

  return (
    <DashboardLayout style={{ display: "flex", flexDirection: "column" }}>
      {actForm
        ? <DirectionCRUDTable reloadValue={reloadValue} onClickDeleteButton={checkRoles('SuperAdministrator') ? handleDelete : null} extraFilter={extraFilter} readonly={readonly} />
        : <div style={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress />
        </div>}
    </DashboardLayout>
  );
};

export default DirectionTable;
